import FlagBaseIcon, { FlagEmojiIconProps } from "./FlagBaseIcon";

const FinlandFlagEmojiIcon = (props: FlagEmojiIconProps) => {
  return <FlagBaseIcon {...props}>🇫🇮</FlagBaseIcon>;
};

export default FinlandFlagEmojiIcon;
